var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-home"},[_c('BannerSwiper'),_c('HomeNews'),_c('HomeIndustry'),_c('PartnerLogos'),_c('ContactSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }